jQuery(document).ready(function ($) {
	// add to event loop because the customer's name is not readily available
	setTimeout(function () {
		// Home Featured Products slider
		$('.home-featuredproducts ul.products').slick({
			slidesToShow: 3,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		});
		// Footer mobile accordions
		$('.af-collapsable-section button').on('click', function (e) {
			$(this).parents('.af-collapsable-section').toggleClass('af-expanded');
			e.preventDefault();
		});

		// Scroll to reviews if Metorik email ID ?mtke=27
		function getParameterByName(name, url = window.location.href) {
			name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		}
		var mtke = getParameterByName('mtke');
		if (mtke == '27') {
			$('a[href="#tab-reviews"]').click();
			$('html, body').animate({ scrollTop: $('.woocommerce-tabs').offset().top - 100 }, 'fast');
		}

		// View More Details link, dev/19646737
		if ($('#tab-description').length) {
			$('.product-more-details').on('click', function (e) {
				$('a[href="#tab-description"]').click();
				$('html, body').animate({ scrollTop: $('.woocommerce-tabs').offset().top - 100 }, 'fast');
				e.preventDefault();
			});
		} else {
			$('.product-more-details').hide();
		}

		// Account flyout
		$('.account-link.account-logged-in > a').on('click', function (e) {
			$(this).parent().toggleClass('open'), $('.uscca-user-flyout').toggleClass('open'), e.preventDefault();
		});
		$(document).mouseup(function (e) {
			var container = $('.account-link, .uscca-user-flyout');
			container.is(e.target) || 0 !== container.has(e.target).length || container.removeClass('open');
		});
		// Create mobile navigation sliding panels
		$('.mobile-navigation.primary-navigation').each(function () {
			$(this)
				.find('> ul > .menu-item-has-children')
				.each(function (i) {
					var $this = $(this),
						myTitle = $this.children('a').text(),
						myUrl = $this.children('a').attr('href'),
						myPanelName =
							'mobile-menu-panel-' +
							(function convertToSlug(text) {
								return text
									.toLowerCase()
									.replace(/[^\w ]+/g, '')
									.replace(/ +/g, '-');
							})(myTitle),
						myPanelClass = 'mobile-menu-panel';
					$this.hasClass('meganav') && (myPanelClass += ' meganav'),
						$this.append('<span class="next" data-uscca-menu-panel="' + myPanelName + '"></span>'),
						$this.find('.more').remove(),
						$('<div/>', {
							id: myPanelName,
							class: myPanelClass,
						})
							.appendTo($this.parents('.mobile-navigation'))
							.append(
								'<p class="mobile-menu-panel-title"><span class="back">Back</span><a href="' +
									myUrl +
									'">' +
									myTitle +
									'</a></p>'
							)
							.append($this.children('ul'));
				});
			$(this).find("a[href*='/account-details']").first().html(`
					<svg xmlns="http://www.w3.org/2000/svg" width="12" height="14">
							<path d="M12 11.5v1.1c0 .7-.6 1.3-1.3 1.3H1.3c-.7 0-1.3-.6-1.3-1.3v-1.1c0-2 1.6-3.6 3.6-3.6H4c.6.3 1.3.4 2 .4s1.4-.2 2-.4h.4c2 0 3.6 1.6 3.6 3.6zM2.6 3.6C2.6 1.7 4.1.2 6 .2s3.4 1.5 3.4 3.4S7.9 7 6 7 2.6 5.5 2.6 3.6z" fill="#747678"></path>
					</svg> Account`);
		});

		var $mobileMenuNextButtons = $('[data-uscca-menu-panel]'),
			$mobileMenuPrevButtons = $('.mobile-menu-panel-title span'),
			$mobileMenuPanels = $('.mobile-menu-panel');

		function menuCloseAll(e) {
			e.preventDefault(), $mobileMenuPanels.removeClass('active');
		}
		$mobileMenuNextButtons.on('click', function menuNextClick(e) {
			e.preventDefault();
			var $button = $(e.currentTarget);
			var panelId = $button.attr('data-uscca-menu-panel');
			var $panel = $('#' + panelId);
			menuCloseAll(e);
			$panel.addClass('active');
		});
		$mobileMenuPrevButtons.on('click', menuCloseAll),
			$('.mobile-submenu-contact-toggle').on('click', function (e) {
				$('body').toggleClass('mobile-contact-open'), e.preventDefault();
			});
		$('.menu-toggle').on('click', function (e) {
			$('body').toggleClass('mobile-menu-open'),
				$(this)
					.children('span')
					.text(function (i, text) {
						return 'Menu' === text ? 'Close' : 'Menu';
					}),
				e.preventDefault();
		}),
			$('.mobile-menu-overlay').on('click', function (e) {
				$('body').removeClass('mobile-menu-open'), e.preventDefault();
			}),
			$('.search-icon .tools_button').on('click', function (e) {
				$('body').toggleClass('site-search-open'),
					$('body').removeClass('mobile-menu-open'),
					$('#search-input').focus(),
					e.preventDefault();
			}),
			$('.site-search-flyout-close').on('click', function (e) {
				$('body').removeClass('site-search-open'), e.preventDefault();
			}),
			$(document).mouseup(function (e) {
				var container = $('.search-icon .tools_button, .site-search-flyout');
				container.is(e.target) || 0 !== container.has(e.target).length || $('body').removeClass('site-search-open');
			});
	}, 0);

	// Default Gallery - Scroll thumbnails dev/19646689
	$(document).on(
		'click touchend',
		'.product_layout_classic ol.flex-control-thumbs li img, .product_layout_classic .flex-direction-nav a',
		function () {
			if ($(window).width() >= 1025) {
				var product_thumbnails = $('ol.flex-control-thumbs');
				var product_thumbnails_cells = product_thumbnails.find('li');
				var product_thumbnails_width = product_thumbnails.width();
				var product_thumbnails_cells_width = product_thumbnails_cells.outerWidth();
				var index = $(
					'.woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image.flex-active-slide'
				).index();

				var scrollX =
					index * product_thumbnails_cells_width - (product_thumbnails_width - product_thumbnails_cells_width) / 2 - 10;

				product_thumbnails.animate({ scrollLeft: scrollX }, 300);
			}
		}
	);
});
